export default class Transfer {
  constructor() {
    this.$transferListItems = document.querySelectorAll('.js-transfer-list-item');

    this.init();
  }

  init() {
    this.$transferListItems && this.$transferListItems.forEach((transferListItem) => {
      transferListItem.addEventListener('click', (element) => this.selectTransferItem(element));
    });
  }

  selectTransferItem(element) {
    const target = element.currentTarget;
    const transferList = element.target.closest('.js-transfer-list');
    const transferListItems = transferList.querySelectorAll('.js-transfer-list-item');
    const inputRadio = target.querySelector('input[type="radio"]');

    inputRadio.checked = true;

    transferListItems.forEach((transferListItem) => {
      transferListItem.classList.remove('selected');
    });

    target.classList.add('selected');
  }
}



/** WEBPACK FOOTER **
 ** ./assets/js/pages/transfer.js
 **/